import { createStructuredSelector } from 'reselect'

import {
  REVIEW_DETAIL,
  REVIEW_DETAIL_SUCCESS,
  REVIEW_DETAIL_ERROR,
  REVIEW_ADD_SET,
  REVIEW_ADD_CHANGE,
  REVIEW_EDIT_MODAL_SET,
  REVIEW_ADD_MODAL_SET,
  REVIEW_EDIT_TAB_SET,
  REVIEW_SEARCH,
  REVIEW_SEARCH_SUCCESS,
  REVIEW_SEARCH_ERROR,
  REVIEW_ADD,
  REVIEW_ADD_SUCCESS,
  REVIEW_ADD_ERROR,
  REVIEW_HEADER,
  REVIEW_SEARCH_REVIEW_STATE_LIST,
  REVIEW_SEARCH_REVIEW_STATE_LIST_SUCCESS,
  REVIEW_SEARCH_REVIEW_STATE_LIST_ERROR,
  REVIEW_SEARCH_SUPPLIER_LIST,
  REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  REVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  REVIEW_LIST,
  REVIEW_LIST_SUCCESS,
  REVIEW_LIST_ERROR,
  REVIEW_SEARCH_SET,
  REVIEW_SEARCH_CHANGE,
  REVIEW_PAGE_SET,
  REVIEW_VIEW_MODAL_SET,
  REVIEW_VIEW_DETAIL_MODAL_SET,
  REVIEW_VIEW_SET,
  REVIEW_VIEW_TAB_SET,
  REVIEW_EDIT_CHANGE,
  REVIEW_UPDATE,
  REVIEW_UPDATE_SUCCESS,
  REVIEW_UPDATE_ERROR
} from '../actions';

export const NAME = 'review';

export const ReviewDetail = (data) => ({
  type: REVIEW_DETAIL,
  payload: data
});

export const ReviewDetailSuccess = (data) => ({
  type: REVIEW_DETAIL_SUCCESS,
  payload: data
});

export const ReviewDetailError = (error) => ({
  type: REVIEW_DETAIL_ERROR,
  payload: error
});

export const ReviewAddSet = (data) => ({
  type: REVIEW_ADD_SET,
  payload: data
});

export const ReviewAddChangeSet = (data) => ({
  type: REVIEW_ADD_CHANGE,
  payload: data
});

export const ReviewEditModalSet = (data) => ({
  type: REVIEW_EDIT_MODAL_SET,
  payload: data
});

export const ReviewAddModalSet = (data) => ({
  type: REVIEW_ADD_MODAL_SET,
  payload: data
});

export const ReviewEditTabSet = (data) => ({
  type: REVIEW_EDIT_TAB_SET,
  payload: data
});

export const ReviewViewTabSet = (data) => ({
  type: REVIEW_VIEW_TAB_SET,
  payload: data
});

export const ReviewSearch = (data) => ({
  type: REVIEW_SEARCH,
  payload: data
});

export const ReviewSearchSuccess = (data) => ({
  type: REVIEW_SEARCH_SUCCESS,
  payload: data
});

export const ReviewSearchError = (error) => ({
  type: REVIEW_SEARCH_ERROR,
  payload: error
});

export const ReviewAdd = (data) => ({
  type: REVIEW_ADD,
  payload: data
});

export const ReviewAddSuccess = (data) => ({
  type: REVIEW_ADD_SUCCESS,
  payload: data
});

export const ReviewAddError = (error) => ({
  type: REVIEW_ADD_ERROR,
  payload: error
});

export const ReviewHeader = (data) => ({
  type: REVIEW_HEADER,
  payload: data
});

export const ReviewSearchReviewStateList = () => ({
  type: REVIEW_SEARCH_REVIEW_STATE_LIST
});

export const ReviewSearchReviewStateListSuccess = (message) => ({
  type: REVIEW_SEARCH_REVIEW_STATE_LIST_SUCCESS,
  payload: message
});

export const ReviewSearchReviewStateListError = (error) => ({
  type: REVIEW_SEARCH_REVIEW_STATE_LIST_ERROR,
  payload: error
});

export const ReviewSearchSupplierList = () => ({
  type: REVIEW_SEARCH_SUPPLIER_LIST
});

export const ReviewSearchSupplierListSuccess = (message) => ({
  type: REVIEW_SEARCH_SUPPLIER_LIST_SUCCESS,
  payload: message
});

export const ReviewSearchSupplierListError = (error) => ({
  type: REVIEW_SEARCH_SUPPLIER_LIST_ERROR,
  payload: error
});

export const ReviewList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: REVIEW_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ReviewListSuccess = (data) => ({
  type: REVIEW_LIST_SUCCESS,
  payload: data
});

export const ReviewListError = (error) => ({
  type: REVIEW_LIST_ERROR,
  payload: error
});

export const ReviewSearchSet = (data) => ({
  type: REVIEW_SEARCH_SET,
  payload: data
});

export const ReviewSearchChangeSet = (data) => ({
  type: REVIEW_SEARCH_CHANGE,
  payload: data
});

export const ReviewPageSet = (data) => ({
  type: REVIEW_PAGE_SET,
  payload: data
});

export const ReviewViewModalSet = (data) => ({
  type: REVIEW_VIEW_MODAL_SET,
  payload: data
});

export const ReviewViewDetailModalSet = (data) => ({
  type: REVIEW_VIEW_DETAIL_MODAL_SET,
  payload: data
});


export const ReviewViewSet = (data) => ({
  type: REVIEW_VIEW_SET,
  payload: data
});

export const ReviewEditChangeSet = (data) => ({
  type: REVIEW_EDIT_CHANGE,
  payload: data
});

export const ReviewUpdate = (data) => ({
  type: REVIEW_UPDATE,
  payload: data
});

export const ReviewUpdateSuccess = (message) => ({
  type: REVIEW_UPDATE_SUCCESS,
  payload: message.message
});

export const ReviewUpdateError = (error) => ({
  type: REVIEW_UPDATE_ERROR,
  payload: error
});

const review = (state) => state[NAME];
export const ReviewSelector = createStructuredSelector({
  review
})
